import React from 'react';
import './circularTimer.scss';

type CircularTimerProps = {
  percentage: number;
  size: number;
  strokeWidth: number;
  text: string;
  subText: string;
};

export const CircularTimer: React.FC<CircularTimerProps> = ({
  percentage,
  size,
  strokeWidth,
  text,
  subText,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  const status = percentage === 0 ? 'danger' : 'primary';

  return (
    <svg width={size} height={size} className="circular-progress-bar">
      {/* Background circle */}
      <circle
        className={`circle-background-${status}`}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
      />
      {/* Progress circle */}
      <circle
        className={`circle-progress-${status}`}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={-offset}
      />
      {/* Text */}
      <text
        x="50%"
        y="40%"
        dominantBaseline="middle"
        textAnchor="middle"
        className={`circle-text-${status}`}
      >
        {text}
      </text>
      <text
        x="50%"
        y="60%"
        dominantBaseline="middle"
        textAnchor="middle"
        className={`circle-sub-text-${status}`}
      >
        {subText}
      </text>
    </svg>
  );
};
